import React, { useState } from 'react'

const ForPartnersOrganization = ({ register, errors }) => {
    const [isFocused, setIsFocused] = useState<boolean>(false)

    return (
        <div className={`for-partners__input-block ${isFocused && 'for-partners__input-block_focused'}`}>
            <label htmlFor='name'>название организации</label>
            {errors.organization && <p style={{ color: 'red', fontSize: 12 }}>{errors.organization.message ? errors.organization.message : 'введены некорректные данные'}</p>}
            <input
                style={errors.name ? { color: 'red' } : {}}
                autoComplete='off'
                onBlurCapture={() => setIsFocused(false)}
                onFocus={() => setIsFocused(true)}
                name='organization'
                type='text'
                placeholder='ООО «Рога и копыта»'
                {...register('organization', {
                    minLength: {
                        value: 4,
                        message: 'название организации должно содержать мин. 4 буквы'
                    }, required: false,
                })}
            />
        </div>
    )
}

export default ForPartnersOrganization
